import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	title: {
		id: 'contextual-summary.project-summary.csat-over-time.title',
		defaultMessage: 'Average CSAT over time',
		description: 'Title of the average CSAT over time chart.',
	},
});
